const env = process.env;

export const LEGAL_DETAILS = {
  brandName: 'Fate Room',
  operatorName: env.REACT_APP_LEGAL_OPERATOR_NAME || 'Peter Lipovský',
  legalForm: env.REACT_APP_LEGAL_FORM || 'Sole trader',
  businessId: env.REACT_APP_BUSINESS_ID || '23199393',
  taxId: env.REACT_APP_TAX_ID || '',
  vatId: env.REACT_APP_VAT_ID || '',
  registeredOffice: env.REACT_APP_REGISTERED_OFFICE || '',
  registerName: env.REACT_APP_TRADE_REGISTER || '',
  supportEmail: env.REACT_APP_SUPPORT_EMAIL || 'support@fateroom.eu',
  privacyEmail: env.REACT_APP_PRIVACY_EMAIL || 'support@fateroom.eu',
};

export const hasCompleteBusinessDetails = Boolean(
  LEGAL_DETAILS.operatorName
  && LEGAL_DETAILS.businessId
  && LEGAL_DETAILS.registeredOffice
  && LEGAL_DETAILS.registerName,
);

export const privacyMailto = `mailto:${LEGAL_DETAILS.privacyEmail}?subject=${encodeURIComponent(
  'Fate Room privacy request',
)}`;
